// ======================================================================
// File Name       : service
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const RECEIVE_SERVICE_NOTIFICATION_LIST = 'RECEIVE_SERVICE_NOTIFICATION_LIST';
export const RECEIVE_SERVICE_NOTICE_DETAIL = 'RECEIVE_SERVICE_NOTICE_DETAIL';
export const INIT_SERVICE_NOTICE_DETAIL = 'INIT_SERVICE_NOTICE_DETAIL';
export const STORE_SERVICE_USER_LIST = 'STORE_SERVICE_USER_LIST';
export const ADD_SERVICE_USER_TO_LIST_BY_GROUPS = 'ADD_SERVICE_USER_TO_LIST_BY_GROUPS';
export const ADD_SERVICE_USER_TO_LIST = 'ADD_SERVICE_USER_TO_LIST';
export const REMOVE_SERVICE_USER_FROM_LIST = 'REMOVE_SERVICE_USER_FROM_LIST';
export const RESET_EDITING_SERVICE_USERS = 'RESET_EDITING_SERVICE_USERS';
export const ALL_USER_RECEIVED = 'ALL_USER_RECEIVED';
export const REMOVED_ALL_USER_RECEIVED = 'REMOVED_ALL_USER_RECEIVED';
export const INITIALIZE_VIDEO_SPEED_OPTIONS = 'INITIALIZE_VIDEO_SPEED_OPTIONS';
export const UPDATE_VIDEO_SPEED_USAGE = 'UPDATE_VIDEO_SPEED_USAGE';
export const SERVICE_INPUT_CHANGE = 'SERVICE_INPUT_CHANGE';
export const RESET_SERVICE_NOTICE_DETAIL = 'RESET_SERVICE_NOTICE_DETAIL';
